import { Client, ScenarioSettings } from "src/types";
import title from "../calculator/title";
import { getTaxRate, yearRange } from "../utils";
import MainChart from "./Charts/MainChart";
import Header from "./Report/Header";
import { calculateSpendingYear } from "./Spending/calculate";
import { useScenario } from "src/hooks/useScenario";
import { useUser } from "src/hooks/useUser";

interface MapChartProps {
  settings: ScenarioSettings;
  client: Client;
  print?: boolean;
}

const MapChart = ({ settings, client, print }: MapChartProps) => {
  const { scenario } = useScenario();
  const { user } = useUser();
  const incomes = settings.incomes.filter((inc) => inc.enabled);
  const startYear = new Date().getFullYear();
  const divisionFactor =
    client.liveSettings.monthlyYearly === "monthly" ? 12 : 1;

  const taxes = (line: any) => {
    if (!scenario[line]) return 0;
    const income = settings.incomes
      .filter((income) => income.enabled)
      .map((income) => scenario[line]?.incomes[income.id]?.amount)
      .filter((t) => typeof t === "number")
      .reduce((a, b) => a + b, 0);

    const taxRate = getTaxRate(user, settings, line);
    return income * taxRate;
  };

  return (
    <div className={`bg-white ${!print && "pb-5"} ${print && "mr-5"}`}>
      <Header client={client as any} scenario={settings} page="Incomes" />
      <MainChart
        print={print}
        years={yearRange(startYear, startYear + settings.maxYearsShown - 1)}
        spending={false}
        initialHeight={print ? 660 : 550}
        longevityFlag={!!user?.info?.longevityFlag}
        people={client.people}
        lineData={
          user?.info?.needsFlag
            ? yearRange(startYear, startYear + settings.maxYearsShown - 1).map(
              (currentYear) =>
                calculateSpendingYear(
                  client.people,
                  client.spending,
                  { ...settings, taxType: "Pre" },
                  currentYear,
                ) /
                divisionFactor +
                (settings.taxType == "Post" ? taxes(currentYear) : 0),
            )
            : []
        }
        taxes={
          user?.info?.needsFlag && settings.taxType === "Post"
            ? yearRange(startYear, startYear + settings.maxYearsShown - 1).map(
              (line) => taxes(line),
            )
            : []
        }
        stability={!!user?.info?.stabilityRatioFlag}
        needsFlag={!!user?.info?.needsFlag}
        stackedData={incomes.map((income, i) => ({
          name: title(incomes, client.people, i),
          stable: income.stable,
          values: yearRange(
            startYear,
            startYear + settings.maxYearsShown - 1,
          ).map((year) =>
            Math.round(scenario[year]?.incomes[income.id]?.amount),
          ),
        }))}
      />
    </div>
  );
};

export default MapChart;
